export class ErrorMessage {
    static PROPERTY_IS_NOT_FOUND(propertyName: string, containingObject) {
        return `property '${propertyName}' is not found on: \n ${JSON.stringify(containingObject, null, 2)}`;
    }
}
